import $ from 'jquery';
import Flickity from 'flickity';

import ThemeUtils from '../utils/ThemeUtils';

export default class StaticSlideshow {
  constructor(section) {
    this.$el = $('.slideshow-section', $(section.el));
    this.$window = $(window);
    this.$document = $(document.body);
    this.mainHeader = $('[data-main-header]');
    this.headerLogo = $('[data-header-logo]', this.mainHeader);

    this.slideshow = null;
    this.$viewport = null;

    this.slideContainer = '[data-slideshow-container]';
    this.$slideContainer = $(this.slideContainer);
    this.slideSelector = '[data-slide]';
    this.enableNavigation = $(this.slideSelector).length > 1;

    this.$paginationContainer = $('[data-slideshow-pagination]');
    this.paginationItem = '[data-pagination-slide]';
    this.hasThumbnailPagination = this.$paginationContainer.length !== 0;

    this.slideshowDuration = parseInt(this.$el.attr('data-autoplay'), 10);

    this.sectionStyle = (this.$el.attr('data-section-style') != null)
      ? this.$el.attr('data-section-style')
      : false;

    this.setupHeader(this.$el);
    this._init();
  }

  _init() {
    const flickityOptions = {
      autoPlay: this.enableNavigation ? this.slideshowDuration : 0,
      cellSelector: this.slideSelector,
      cellAlign: 'center',
      draggable: this.enableNavigation,
      freeScroll: false,
      pageDots: (!this.hasThumbnailPagination && this.enableNavigation),
      prevNextButtons: this.enableNavigation,
      setGallerySize: false,
      wrapAround: true,
    };

    this.slideshow = new Flickity(this.slideContainer, flickityOptions);
    this.$slideshow = $(this.slideshow.element);
    this.$viewport = this.$slideshow.find('.flickity-viewport');

    this._bindSlideshow();
    if (this.sectionStyle) {
      this._sectionStyle(true);
    }

    if (this.hasThumbnailPagination) {
      this._bindPagination();
      this._updatePagination(this.slideshow.selectedIndex);
    }
  }

  _bindSlideshow() {
    /*
            On slide change, find the new height of the slide and set it as the
            height of the slider

            TODO: On upgrade to Flickity 2, change this to `select`
        */
    this.slideshow.on('select', () => {
      this.$slideshow.trigger('heightUpdate');
      this._updatePagination(this.slideshow.selectedIndex);
    });

    this.$slideshow.on('heightUpdate', () => this._setSlideHeight());

    // Sets the Slider to the height of the first slide
    this.$slideshow.trigger('heightUpdate');
    this.$slideshow.on('rimg:load', () => this.$slideshow.trigger('heightUpdate'));

    this.$window.on('resize.slideshow', ThemeUtils.debounce(() => this.$slideshow.trigger('heightUpdate'),
      10));
  }

  _bindPagination() {
    this.$paginationContainer.on('click', this.paginationItem, (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget);

      const slideTarget = parseInt($target.attr('data-pagination-slide'), 10) - 1;

      this.slideshow.select(slideTarget);
      this._updatePagination(slideTarget, $target);
    });
  }

  _updatePagination(slideTarget, $target = null) {
    if (typeof target === 'undefined' || target === null) {
      $target = this.$paginationContainer.find(this.paginationItem).eq(slideTarget);
    }

    $target
      .addClass('is-selected')
      .siblings('.is-selected')
      .removeClass('is-selected');
  }

  _setSlideHeight(minHeight = null) {
    let height;
    const isOpeningScreen = this.$el.hasClass('opening-screen');
    const isDesktop = ThemeUtils.windowWidth() >= 720;
    const $element = $(this.slideshow.selectedElement);
    const $elementImage = $element.find('.slide-image');
    const $elementText = $element.find('.slide-text');

    const $pagination = this.$el.find('.flickity-prev-next-button');

    if (isDesktop) {
      $pagination.height('');
    }

    if (isDesktop && isOpeningScreen) {
      const $promotionBar = $('[data-promotion-bar]');

      if (!$promotionBar.length) { return; }

      height = window.innerHeight - $promotionBar.outerHeight();

      if (this.hasThumbnailPagination) {
        height -= this.$paginationContainer.outerHeight(true);
      }

      $element.height(height);
      this.$viewport.height(height);
      this.$slideContainer.height(height);
      this.$el.height(height);
    }

    const heights = [];
    heights.push(minHeight);
    heights.push($element.height());

    const imageHeight = $elementImage.outerHeight(true);
    const textHeight = $elementText.length ? $elementText.outerHeight(true) : 0;

    if (isDesktop) {
      heights.push(imageHeight);
      heights.push(textHeight);
    }

    height = Math.max.apply(null, heights);

    if (((imageHeight <= textHeight) || $('.full-slideshow-wrapper').hasClass('content-width')) && isDesktop) {
      height = imageHeight;
    }

    if (isOpeningScreen) {
      this.$slideContainer.height('');
      this.$el.height('');
    }

    if (isDesktop) {
      $element.height(height);
    } else {
      $element.height('');
      $pagination.height(textHeight ? imageHeight : height);
    }

    this.$viewport.height(height);
  }

  _sectionStyle(force) {
    const $section = this.$el.parent('.shopify-section');
    $section.toggleClass(this.sectionStyle, force);
  }

  /*
        Public method for SlideshowSection
            - Pauses the slideshow
            - Brings the current slide into view
    */
  lockSlide(block) {
    this.slideshow.pausePlayer();

    this.$el.toggleClass('slider-locked', true);

    const index = block.el.getAttribute('data-slide') - 1;
    this.slideshow.select(index, false, true);
  }

  /*
        Public method for SlideshowSection
            - Unpause the slideshow
    */
  unlockSlide() {
    this.slideshow.unpausePlayer();
    this.$el.toggleClass('slider-locked', false);
  }

  /*
        Public method for SlideshowSection
            - Destroy the slideshow
            - Unbind events
    */
  prepareRemove() {
    if (this.$paginationContainer.length) {
      this.$paginationContainer.off('click', this.paginationItem);
    }

    if (this.sectionStyle) {
      this._sectionStyle(false);
    }

    this.$window.off('resize.slideshow');
    this.$slideshow.off('heightUpdate');
    this.slideshow.off('select');
    this.slideshow.destroy();
  }

  /*
        Triggers Logo swapping, or sticky header offsets
    */
  setupHeader($el) {
    if (this.headerLogo.length) {
      $(document.body).trigger('swapLogo');
    }

    if ($el && ($el.attr('data-full-bleed-slideshow') != null)) {
      this.mainHeader.addClass('full-bleed-slideshow');
    } else {
      this.mainHeader.removeClass('full-bleed-slideshow');
    }

    $(document.body).trigger('toggleStickyHeader', [$el])
      .trigger('toggleSlideShowHeader', [$el]);
  }

  onSectionUnload() {
    this.prepareRemove();
    this.setupHeader(null);
  }

  onSectionBlockSelect(event) {
    this.lockSlide(event);
  }

  onSectionBlockDeselect() {
    this.unlockSlide();
  }
}
